import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState } from '../../core';
import { CallLogRecord } from '../../core/models/call-log-record';

import { PostProcessingService } from '../../core/services';
import { StatMetric, TableViewComponentBase, TableViewQueryRequest } from '../../shared/components/table-view/table-view-component-base';
import { CallLogsTableCellComponent } from './call-logs-table-cell.component';



@Component({
  selector: 'app-call-logs',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss'
  ]
})
export class CallLogsComponent extends TableViewComponentBase<CallLogRecord> implements OnInit, OnDestroy {

  constructor(
      appState: AppState,
      modalService: BsModalService,
      public postProcessingService: PostProcessingService,
      elementRef: ElementRef,
      datePipe: DatePipe
  ){
    super(appState,modalService,elementRef,datePipe)
    this.tableCellRenderer = CallLogsTableCellComponent
    this.tableColumns  = [
      { title:'Query Row ID', name: 'viewrowid', visible: false},
      { title:'Source ID', name: 'sourceid', visible: true},
      { title:'Import File Id', name: 'importfileid', visible: false},
      { title:'Log Name', name: 'logname', visible: false},
      { title:'Log Row#', name: 'logrownum', visible: false},
      { title:'Test Type', name: 'testtype', visible: true},
      { title:'Stage', name: 'stage', visible: true},
      { title:'Market', name: 'market', visible: false},
      { title:'Morphology', name: 'morphology', visible: false},
      { title:'Building', name: 'buildingid', visible: true},
      { title:'Carrier', name: 'participant', visible: true},
      { title:'User ID', name: 'userid', visible: false, template: 'user'},
      { title:'User Name', name: 'username', visible: true, template: 'user'},
      { title:'Handset MAC', name: 'phonemac', visible: false},
      { title:'Handset OS', name: 'os', visible: true},
      { title:'Handset ID', name: 'handsetid', visible: false},
      { title:'Handset Model', name: 'handsetmodel', visible: true},
      { title:'Path', name: 'pathid', visible: false},
      { title:'Point', name: 'pointid', visible: true },
      { title:'Cycle', name: 'cycle', visible: true},
      { title:'Test Point', name: 'testpointid', visible: true},
      { title:'Task', name: 'taskid', visible: false},
      { title:'Correlated?', name: 'correlationtime', visible: true, template: 'correlationLink'},
      { title:'Call Start Time', name: 'starttime', visible: true, template: 'fulltime'},
      { title:'Call End Time', name: 'endtime', visible: true, template: 'fulltime'},
      { title:'Call Duration', name: 'duration', visible: true, template: 'fixed4'},
      { title:'Call Setup', name: 'setup', visible: true, template: 'fixed4'},
      { title:'Call Traffic', name: 'traffic', visible: true, template: 'fixed4'},
      { title:'Dialed Number', name: 'dialednum', visible: true},
      { title:'Phone Number', name: 'phonenum', visible: true},
      //{ title:'Participant', name: 'participant', visible: false},
      { title:'Baro', name: 'baro', visible: false},
      { title:'Grouping Field', name: 'groupingfield', visible: false},
      { title:'Comments', name: 'comments', visible: false},
    ]
    this.sortColumns = [
      { key: 'starttime', order: 'DESC'},
    ];
    const metrics: StatMetric[] = [
      { column: 'setup', statTypes: ['min','max','avg']},
      { column: 'traffic', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'duration', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'starttime', format: { dataType: 'date' }, statTypes: ['min','max']},
      { column: '*', format: { dataType: 'number' }, statTypes: ['count']},
    ]
    this.statGroups = [
      {
        id: 'byParticipant',
        groupBy: ['participant'],
        visible: true,
        metrics,
      },
      {
        id: 'byOs',
        title: 'OS',
        groupBy: ['os'],
        visible: false,
        metrics,
      },
      {
        id: 'byModel',
        title: 'Model',
        groupBy: ['handsetmodel'],
        visible: false,
        metrics,
      },
      {
        id: 'byTestType',
        groupBy: ['testtype'],
        visible: false,
        metrics,
      },
      {
        id: 'byBuilding',
        groupBy: ['buildingid'],
        visible: false,
        metrics,
      },
      {
        id: 'byBuildingPoint',
        groupBy: ['buildingid','pointid'],
        visible: false,
        metrics,
      },
      {
        id: 'byParticipantOsHandsetModel',
        groupBy: ['participant','os','handsetmodel',],
        visible: false,
        metrics,
      },
    ];
  }


  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }


  doQuery = async ( queryReq: TableViewQueryRequest ) => this.postProcessingService.findCallLogRecords(queryReq)

}
